// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  missionHoldId: __t.u64().primaryKey().name("mission_hold_id"),
  identity: __t.identity(),
  sid: __t.u64(),
  slot: __t.u32(),
  epoch: __t.u32(),
  kind: __t.string(),
  species: __t.string(),
  targetSiteId: __t.i64().name("target_site_id"),
  wayX: __t.f32().name("way_x"),
  wayZ: __t.f32().name("way_z"),
  needed: __t.u32(),
  progress: __t.u32(),
  rewardSov: __t.i64().name("reward_sov"),
  standing: __t.u32(),
  state: __t.string(),
  takenAt: __t.timestamp().name("taken_at"),
});
